import { Container } from 'pixi.js';
import { ACHIEVEMENTS } from '@/config/achievements';
import { COLORS } from '@/config/colors';
import { hasAchievement } from '@/core/meta';
import { t } from '@/i18n';
import { ACHIEVEMENT_ROW_H, buildAchievementRow } from './achievement-badges';
import { label } from './widgets';

/** Achievements panel design space (scaled to fit the canvas). */
export const ACH_LAYOUT = { w: 1060, h: 500, colGap: 20, rowGap: 12, top: 74, backY: 456 };

/**
 * Title ACHIEVEMENTS panel (docs/01 achievements): every achievement in two
 * columns — earned ones gold, open ones dimmed — with what each unlocks.
 */
export function buildAchievementsPanel(): Container {
  const c = new Container();
  const L = ACH_LAYOUT;
  const earned = ACHIEVEMENTS.filter((a) => hasAchievement(a.id)).length;
  const head = label(t('ach.title'), 26, COLORS.playerYellow, 4);
  head.anchor.set(0.5, 0);
  head.position.set(L.w / 2, 0);
  const progress = label(
    t('ach.progress', { n: earned, m: ACHIEVEMENTS.length }), 14, COLORS.uiAccent, 2,
  );
  progress.anchor.set(0.5, 0);
  progress.position.set(L.w / 2, 38);
  c.addChild(head, progress);

  const colW = (L.w - L.colGap) / 2;
  const perCol = Math.ceil(ACHIEVEMENTS.length / 2);
  ACHIEVEMENTS.forEach((def, i) => {
    const col = Math.floor(i / perCol);
    const row = i % perCol;
    const node = buildAchievementRow(def, hasAchievement(def.id), colW);
    node.position.set(col * (colW + L.colGap), L.top + row * (ACHIEVEMENT_ROW_H + L.rowGap));
    c.addChild(node);
  });
  return c;
}
